import * as Yup from "yup";
import {
  FIELD_REQUIRED,
  MUST_BE_NUMBER_FOR_TOKEN
} from "../../../../../utils/constants";
import { TokenHistoryLabel } from "kadow-jetpack-model";
import { CreateErrorOptions, ValidationError } from "yup";
import TSUtils from "../../../../../utils/helpers/TSUtils";
import { tt } from "../../../../../utils/i18n/i18n";

export const buildCTAValidationSchema = () => {
  let schema = Yup.object({});

  schema = Yup.object({
    ctas: Yup.array().of(
      Yup.object().shape({
        id: Yup.string().required(FIELD_REQUIRED),
        // icon: Yup.string().required(FIELD_REQUIRED),
        // title: Yup.string().required(FIELD_REQUIRED),
        gain: Yup.number()
          .typeError(MUST_BE_NUMBER_FOR_TOKEN)
          .min(1, tt("jetpack_config_cta_gain_min_error")),
        customAction: Yup.string().optional()
      })
    ),
    phoneNumber: Yup.string().optional(),
    socials: Yup.object().optional().shape({
      instagram: Yup.string().optional(),
      googlePlaceId: Yup.string().optional(),
      facebook: Yup.string().optional(),
      tiktok: Yup.string().optional(),
      snapchat: Yup.string().optional(),
      ecommerce: Yup.string().optional(),
      googleAddress: Yup.string().optional()
    }),
    companyId: Yup.string().optional(),
    cic: Yup.string().optional(),
    mn: Yup.array().of(Yup.string()).optional()
  })
    .test(
      "TripAdvisor",
      tt("jetpack_config_cta_test_error"),
      (value, { createError }) => {
        const errors: ValidationError[] = [];
        appendErrorForCTAWithURL(
          TokenHistoryLabel.Custom,
          value,
          errors,
          createError
        );
        appendErrorForCTAWithURL(
          TokenHistoryLabel.TripAdvisor,
          value,
          errors,
          createError
        );
        return errors.length > 0 ? new ValidationError(errors) : true;
      }
    )
    .test("OCR", "dummy", (value, { createError }) => {
      const cta = value.ctas?.find((c) => c.id === TokenHistoryLabel.Receipt);

      if (!cta) {
        return true;
      }

      const res = !!value.mn?.[0] || !!value.mn?.[1] || !!value.mn?.[2];

      if (!res) {
        return createError({
          path: "mn.0",
          message: tt("jetpack_config_ocr_keywords_required")
        });
      }
      return true;
    })
    .test("Check-in", "dummy", (value, { createError }) => {
      const cta = value.ctas?.find((c) => c.id === TokenHistoryLabel.CheckIn);

      if (!cta) {
        return true;
      }

      if (!value.cic || !/^\d{4}$/.test(value.cic)) {
        return createError({
          path: "cic",
          message: tt("jetpack_config_checkin_code_required")
        });
      }

      return true;
    })
    .test("Google Place ID", "dummy", (value, { createError }) => {
      const ctaIdx = value.ctas?.findIndex(
        (c) => c.id === TokenHistoryLabel.Google
      );

      if (ctaIdx == undefined || ctaIdx < 0) {
        return true;
      }

      if (!value.socials?.googlePlaceId || !value.socials?.googleAddress) {
        return createError({
          path: `ctas.${ctaIdx}`,
          message: tt("jetpack_config_google_address_required")
        });
      }
    })
    .test("WhatsApp Group", "dummy", (value, { createError }) => {
      const errors: ValidationError[] = [];
      appendErrorForWhatsAppGroup(value, errors, createError);
      return errors.length > 0 ? new ValidationError(errors) : true;
    });
  return schema;
};

function appendErrorForCTAWithURL(
  id: TokenHistoryLabel,
  value: any,
  errors: ValidationError[],
  createError: (params?: CreateErrorOptions) => ValidationError
) {
  let ctaIdx = value.ctas?.findIndex((c: any) => c.id === id);

  if (ctaIdx === undefined || ctaIdx < 0) {
    return;
  }

  if (!value.ctas?.[ctaIdx]?.customAction) {
    errors.push(
      createError({
        path: `ctas.${ctaIdx}.customAction`,
        message: tt("jetpack_config_cta_link_required")
      })
    );
  } else if (!TSUtils.isValidUrl(value.ctas?.[ctaIdx]?.customAction)) {
    errors.push(
      createError({
        path: `ctas.${ctaIdx}.customAction`,
        message: tt("jetpack_config_cta_link_validation_error")
      })
    );
  }
}

function appendErrorForWhatsAppGroup(
  value: any,
  errors: ValidationError[],
  createError: (params?: CreateErrorOptions) => ValidationError
) {
  const ctaIdx = value.ctas?.findIndex(
    (c: any) => c.id === TokenHistoryLabel.WhatsappGroup
  );

  if (ctaIdx === undefined || ctaIdx < 0) {
    return;
  }

  const whatsappGroupLinkRegex =
    /^https:\/\/chat\.whatsapp\.com\/[A-Za-z0-9]+$/;
  const customAction = value.ctas?.[ctaIdx]?.customAction;

  if (!customAction) {
    errors.push(
      createError({
        path: `ctas.${ctaIdx}.customAction`,
        message: tt("jetpack_config_whatsapp_group_link_required")
      })
    );
  } else if (!whatsappGroupLinkRegex.test(customAction)) {
    errors.push(
      createError({
        path: `ctas.${ctaIdx}.customAction`,
        message: tt("jetpack_config_whatsapp_group_link_invalid")
      })
    );
  }
}
